import React from 'react';
import { View, Text, StyleSheet } from 'react-native-web';
import PropTypes from 'prop-types';
import { Error } from 'Icons/Icons';

interface PropsType {
    error: string;
    style?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    errorIcon?: boolean;
}

const ErrorMessage = (props: PropsType): JSX.Element | null => {
    const { error, style, textStyle, errorIcon } = props;

    if (!error) return null;

    return (
        <View style={[styles.container, style]}>
            {errorIcon && <Error />}
            <Text style={[styles.errorText, textStyle]} numberOfLines={3}>
                {error}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginVertical: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
    },
    errorText: {
        color: 'red',
        fontSize: 13,
        textAlign: 'center',
    },
});

ErrorMessage.propTypes = {
    error: PropTypes.string,
    style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
};

ErrorMessage.defaultProps = {
    error: '',
    style: {},
    textStyle: {},
    errorIcon: false,
};

export default ErrorMessage;
